<template>
  <div>
    <modal-vue class="col-lg-12">
      <div slot="header">
        <h3>Avisos!!!!</h3>
      </div>

      <div slot="body" style="margin:0px;">
         <div class="topics-list">
        <div class="topic" v-for="alert in alertList" :key="alert.id">
          <div class="topic-description-bar" v-if="!alert.read">
            <span>Enviado por: {{alert.userName}} em: {{alert.creationDate | formatDate}}</span>
          </div>
          <div class="topic-title-bar" v-if="!alert.read">
            <div class="text-content">
              <h5
                v-if="alert.text.length<262"
                class="cropped-text"
                style="font-size: 14px;"
              >{{alert.text}}</h5>
              <h5
                v-else
                class="cropped-text"
                style="font-size: 14px;"
              >{{ alert.text.substring(0,262)+"..." }}</h5>
            </div>
          </div>

          <lms-button v-if="!alert.read" :disabled="saving" @click="save(alert)" :loading="saving">Marcar Como Lido</lms-button>
        </div>
         </div>
      </div>

      <div slot="footer">
        <lms-button :disabled="false" @click="close()" class="btn-danger" :loading="false">Lembrar Mais Tarde</lms-button>
      </div>
    </modal-vue>
  </div>
</template>


<style lang="scss" scoped>
</style>


<script>
import axios from "axios";

axios.defaults.withCredentials = true;

export default {
  props: ["alertList"],
  data() {
    return {
      saving: false,
      alert: {},
      userType: this.$store.getters.user.type
    };
  },
  methods: {
    save(alert) {
      console.log("salvando o alerta");
      this.saving = true;
      const path = this.$global.endpoint + "/user/message/markread";
      axios
        .post(path, {
          alert: alert
        })
        .then(res => {
             this.saving = false;
          this.$emit("markedRead");
        })
        .catch(error => {
          this.saving = false;
          console.error(error);
          this.$notify({
            type: "error",
            group: "foo",
            title: "Erro",
            text: error.response.data.error
          });
        });
    },
    close() {
      this.$emit("close");
    }
  },
  created() {
  }
};
</script>
